<template>
    <DCard
        padding
    >
        <div class="mb-5 details">
            <h4>
                {{ __(`tools.emails.email.${template}.name`) }}
            </h4>
            <div class="two-items">
                <strong>{{ __('tools.emails.editor.category') }}: </strong>
                <DTag
                    :label="additions.category"
                />
            </div>
            <div class="two-items">
                <strong>{{ __('tools.emails.editor.sender') }}: </strong>
                <DTag
                    :label="additions.sender_type"
                />
            </div>
            <template
                v-if="additions.sender_type === 'Custom'"
            >
                <div class="two-items">
                    <strong>{{ __('tools.emails.editor.sender_address') }}: </strong>
                    <span>{{ additions.sender_address }}</span>
                </div>
                <div class="two-items">
                    <strong>{{ __('tools.emails.editor.sender_name') }}: </strong>
                    <span>{{ additions.sender_name }}</span>
                </div>
            </template>
            <DButton
                id="edit-additions"
                mini
                :label="__('messages.actions.edit')"
                color="primary"
                @click="openEditAdditionsModal"
            />
        </div>
        <DTable
            :items="existingBrandFlavours"
            :fields="fields"
        >
            <template #brand="{item}">
                <td>
                    {{ formatBrandName(item) ?? + ' ' . item.language.text }}
                </td>
            </template>
            <template #action="{item}">
                <td>
                    <div style="display: flex; grid-gap: 10px;">
                        <DButton
                            mini
                            icon="pencil"
                            @click="editFlavour(item)"
                        />
                        <DButton
                            mini
                            icon="trash-can-outline"
                            color="danger"
                            :disabled="item.id === null"
                            @click="deleteFlavour(item)"
                        />
                    </div>
                </td>
            </template>
        </DTable>
        <DFabs>
            <DFab
                id="btn-add"
                icon="plus"
                :label="__('tools.emails.editor.add')"
                @click="addFlavour"
            />
        </DFabs>
        <EditMailAdditionsModal
            :addition="additions"
            :categories="categories"
            :sender-types="senderTypes"
            :show-modal="showEditAdditionsModal"
            @modalClosed="showEditAdditionsModal = false"
        />
        <DModal
            v-if="showDeleteConfirmationModal"
            v-model:show="showDeleteConfirmationModal"
            :title="__('tools.emails.editor.deleteFlavourModal.title')"
            :message="__('tools.emails.editor.deleteFlavourModal.message')"
            is-confirm
            is-error
            @close="showDeleteConfirmationModal = false"
            @confirm="modalAcceptCallback"
        />
    </DCard>
</template>

<script>

import { __ } from '~@/Composables/translation'
import EditMailAdditionsModal from '~@/Components/Tools/Emails/EditMailAdditionsModal'

export default {
    name: 'EmailEditorIndex',
    components: {
        EditMailAdditionsModal
    },
    props: {
        additions: {
            type: Object,
            default: () => { return {} }
        },
        categories: {
            type: Array,
            default: () => { return [] }
        },
        senderTypes: {
            type: Array,
            default: () => { return [] }
        },
        template: {
            type: String,
            default: null
        },
        existingBrandFlavours: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            fields: [
                { key: 'brand', label: this.__('tools.emails.editor.brand') },
                { key: 'action', label: '' }
            ],
            defaultLanguages: ['EN', 'DE'],
            showDeleteConfirmationModal: false,
            showEditAdditionsModal: false,
            modalAcceptCallback: null
        }
    },
    computed: {
        countDefaultLanguages () {
            return this.existingBrandFlavours.filter(item => item.id === null).length
        }
    },
    methods: {
        addFlavour () {
            this.$inertia.get(this.$route('tools.emails.editor.create', {
                emailType: this.template
            }))
        },
        editFlavour (item) {
            const params = {
                emailType: this.template,
                language_code: item.language.value
            }

            if (item.id !== null) {
                params.brand = item.id
            }

            this.$inertia.get(this.$route('tools.emails.editor.edit', params))
        },
        deleteFlavour (item) {
            this.showDeleteConfirmationModal = true
            this.modalAcceptCallback = () => {
                this.$inertia.delete(this.$route('tools.emails.editor.delete', {
                    emailType: this.template,
                    brand: item.id,
                    language_code: item.language.value
                }))
                this.showDeleteBrandConfirmationModal = false
            }
        },
        formatBrandName (item) {
            if (item.name === null) {
                return __('tools.emails.editor.default') + ' ' + item.language.text
            }

            return item.language ? item.name + ' ' + item.language.text : item.name
        },
        openEditAdditionsModal () {
            this.showEditAdditionsModal = true
            this.modalAcceptCallback = null
        }
    }
}
</script>

<style lang="scss" scoped>
.details {
    align-items: flex-start;
    display: flex;
    grid-gap: 15px;
    flex-direction: column;
}

.two-items {
    display: grid;
    grid-template-columns: 3fr 5fr;
    grid-gap: 15px;
    min-width: 10rem;
    width: 50%;
}
</style>
